import { render } from "./KRCommentActivity.vue?vue&type=template&id=4f772a08"
import script from "./KRCommentActivity.vue?vue&type=script&lang=js"
export * from "./KRCommentActivity.vue?vue&type=script&lang=js"
script.render = render

export default script